import { PREVIEW_COLORS } from './constants';
import dailySparksIcon from './daily-sparks.svg';
import libraryIcon from './library.svg';
import expertTipsIcon from './expert-tips.svg';
import journeyIcon from './journey.svg';

const NAV_ITEMS = [
  { label: 'SPARKS', icon: dailySparksIcon },
  { label: 'LIBRARY', icon: libraryIcon },
  { label: 'EXPERT TIPS', icon: expertTipsIcon },
  { label: 'JOURNEY', icon: journeyIcon },
];

const activeFilter = 'brightness(0) saturate(100%)';
const inactiveFilter = 'brightness(0) saturate(100%) invert(28%) sepia(63%) saturate(454%) hue-rotate(167deg) brightness(95%) contrast(102%)';

export default function PreviewFooter() {
  return (
    <div
      className="absolute bottom-0 left-0 right-0 flex items-center justify-between px-4 flex-shrink-0"
      style={{
        backgroundColor: PREVIEW_COLORS.footerBg,
        borderRadius: '36px 36px 0 0',
        height: '72px',
        paddingBottom: '20px',
        paddingTop: '8px',
      }}
    >
      {NAV_ITEMS.map((item, i) => (
        <div key={i} className="flex flex-col items-center gap-1.5">
          <img
            src={item.icon}
            alt=""
            className="w-5 h-5"
            style={{ filter: i === 0 ? activeFilter : inactiveFilter }}
          />
          <span
            className="text-[8px] font-black tracking-[0.3px] uppercase"
            style={{ color: i === 0 ? PREVIEW_COLORS.navActive : PREVIEW_COLORS.navInactive }}
          >
            {item.label}
          </span>
        </div>
      ))}
    </div>
  );
}
